import api, { Header } from '../../base';
import {
  AllegroCreateOrUpdateReturnPolicyRequest,
  AllegroReturnPolicies,
  AllegroReturnPolicy,
} from './returnPolicyTypes';
import { mockAllegroReturnPolicy, mockGetAllegroReturnPolicies } from './returnPolicyMocks';

const RETURN_POLICIES_PATH = 'allegro-api/after-sales-service-conditions/return-policies';

export async function getAllegroReturnPolicies(
  marketplaceCode: string,
  offset: number = 0,
  limit: number = 60,
  signal?: AbortSignal,
): Promise<AllegroReturnPolicies> {
  const response = await api.get<AllegroReturnPolicies>(RETURN_POLICIES_PATH, {
    headers: {
      [Header.X_ESHOP_CODE]: marketplaceCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    params: { offset, limit },
    signal,
  });

  return response.data;
}

api.mock
  .onGet('allegro-api/after-sales-service-conditions/return-policies')
  .reply(200, mockGetAllegroReturnPolicies);

export async function createAllegroReturnPolicy(
  marketplaceCode: string,
  payload: AllegroCreateOrUpdateReturnPolicyRequest,
  signal?: AbortSignal,
): Promise<AllegroReturnPolicy> {
  const response = await api.post<AllegroReturnPolicy>(
    RETURN_POLICIES_PATH,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPost('allegro-api/after-sales-service-conditions/return-policies')
  .reply(200, mockAllegroReturnPolicy);

export async function updateAllegroReturnPolicy(
  marketplaceCode: string,
  id: string,
  payload: AllegroCreateOrUpdateReturnPolicyRequest,
  signal?: AbortSignal,
): Promise<AllegroReturnPolicy> {
  const response = await api.put<AllegroReturnPolicy>(
    `${RETURN_POLICIES_PATH}/${id}`,
    payload,
    {
      headers: {
        [Header.X_ESHOP_CODE]: marketplaceCode,
        [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
        [Header.CONTENT_TYPE]: 'application/vnd.allegro.public.v1+json',
      },
      signal,
    },
  );

  return response.data;
}

api.mock
  .onPut(/allegro-api\/after-sales-service-conditions\/return-policies\/.+/)
  .reply(200, mockAllegroReturnPolicy);

export async function deleteAllegroReturnPolicy(
  marketplaceCode: string,
  id: string,
  signal?: AbortSignal,
): Promise<void> {
  await api.delete(`${RETURN_POLICIES_PATH}/${id}`, {
    headers: {
      [Header.X_ESHOP_CODE]: marketplaceCode,
      [Header.ACCEPT]: 'application/vnd.allegro.public.v1+json',
    },
    signal,
  });
}

api.mock
  .onDelete(/allegro-api\/after-sales-service-conditions\/return-policies\/.+/)
  .reply(204);
